/**
 * O que falta ao caso digital (E193.F1 — GUS-259, ADR-0139): a lista que o banco, o escritório e a
 * plataforma veem quando o caso fica aguardando arquivos. Os nomes dos arquivos (`content.json`,
 * `.tst`) vêm do material que o cliente envia: é o que ele procura no pacote. E216.F2: o documento
 * declarado sai pelo nome ("Selfie", do rótulo "Hash da Selfie"), sem o hash.
 */
export const ptBRArquivosPendentes = {
  titulo: 'Arquivos que faltam',
  situacao: 'Aguardando arquivos',
  textoDoCliente:
    'O caso fica parado até chegar o que falta. Envie os arquivos pelo complemento do caso.',
  textoDaEquipe: 'O caso está fora da análise até o cliente enviar o que falta pelo complemento.',
  textoDoEnvio: 'Este caso fica aguardando arquivos até chegar o que falta.',
  /** E193.F1.C06: com mais de uma CCB no caso, o carimbo que falta diz de qual ("proposta 29706925"). */
  carimboDaCcb: 'Falta o carimbo do tempo (.tst): {rotulo}',
  /** E193.F1.C10: o recibo do envio enquanto a conferência dos arquivos não termina. */
  conferindo: 'Conferindo os arquivos recebidos…',
  conferenciaSemDesfecho:
    'A conferência dos arquivos ainda não terminou. Abra o caso mais tarde para ver se falta algum arquivo.',
  item: {
    arquivo_de_evidencias: 'Falta o arquivo de evidências (content.json)',
    carimbo_do_tempo: 'Falta o carimbo do tempo (.tst)',
    /** E216.F2 (GUS-317 item 6): o documento declarado pelo nome, sem o hash. */
    documento_declarado: 'Documento declarado no arquivo de evidências e não enviado: {nome}',
  },
} as const;
